// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"66b49b10","439":"97897dc2","453":"10c2fa43","500":"6056b6ef","522":"ed240137","552":"32a9c0c9","722":"af4b38de","845":"70167b67","852":"78da4149"}[chunkId] + ".chunk.js";
};